export const MODAL_DRAWER_KEY = {
  STORE_WITHDRAWAL: 'store_withdrawal',
  STORE_CONFIRM_PURCHASE: 'store_confirm_purchase',
  STORE_SUBSCRIPTION_ERROR: 'store_subscription_error',
}

export const MODAL_DRAWER_IS_CENTER = [MODAL_DRAWER_KEY.STORE_SUBSCRIPTION_ERROR]

export const MODAL_DRAWER_NO_PADDING = [MODAL_DRAWER_KEY.STORE_SUBSCRIPTION_ERROR]
